module.exports = __webpack_public_path__ + "static/img/tvcxc.4559ac6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CCT001/tvcxc.png
// module id = O34h
// module chunks = 1